export class ResumableUploadError extends Error {
  readonly name = "ResumableUploadError";

  constructor(
    readonly code: string,
    message: string,
    readonly status?: number,
  ) {
    super(message);
  }
}
